module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <label class=\"w-100 custom-file mb-3\">\n      <input type=\"file\" name=\"head\" ng2FileSelect [uploader]=\"uploader\" class=\"custom-file-input\" />\n      <span class=\"custom-file-control\">选择文件</span>\n    </label>\n    <ngb-progressbar type=\"primary\" [value]=\"uploader.progress\"></ngb-progressbar>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/upload-simple/upload-simple.component.html
// module id = ../../../../../src/app/shared/upload-simple/upload-simple.component.html
// module chunks = main